import React from 'react';
import { BookOpen } from 'lucide-react';

export default function BookCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('book-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-purple-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <BookOpen className="w-12 h-12 text-purple-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Find Your Perfect Book Title?
        </h2>
        <p className="text-xl text-purple-100 mb-8">
          Join thousands of authors who've found their perfect title with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-purple-600 text-lg px-8 py-4 rounded-lg hover:bg-purple-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Create Your Book Title Now!
        </button>
        <p className="mt-6 text-sm text-purple-200">
          Perfect for fiction, non-fiction, academic, and children's books
        </p>
      </div>
    </section>
  );
}